import { FC } from 'react';
import { StyleSheet, View } from '@react-pdf/renderer';
import Column from '../Pdf/components/Column';
import theme from '../Pdf/components/theme';
import PeriodEndReportPage from './components/pdf/PeriodEndReportPage';
import SectionTitle from './components/pdf/SectionTitle';
import FundOverviewDataPoint from './components/pdf/FundOverviewDatapoint';
import {
  PeriodEndReportSectionPageProps,
  PeriodEndReportFundOverviewDataPoint,
} from './types';

const styles = StyleSheet.create({
  container: {
    width: '400px',
    marginTop: theme.spacing(theme.spacingSizes.md),
    paddingRight: theme.spacing(theme.spacingSizes.lg),
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
    borderStyle: 'solid',
    borderRadius: 6,
    overflow: 'hidden',
    backgroundColor: theme.palette.background.default,
  },
  containerInner: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    width: '100%',
  },
  leftGutter: {
    width: theme.spacing(theme.spacingSizes.lg),
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  tableBody: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
  },
});

type Props = PeriodEndReportSectionPageProps & {
  dataPoints: Array<PeriodEndReportFundOverviewDataPoint>;
};

const FundOverview: FC<Props> = ({ dataPoints, sectionNumber, ...rest }) => {
  return (
    <PeriodEndReportPage {...rest}>
      <SectionTitle sectionNumber={sectionNumber} title="Fund overview" />
      <Column centered>
        <View style={styles.container}>
          <View style={styles.containerInner}>
            <View style={styles.leftGutter} />
            <View style={styles.tableBody}>
              {dataPoints.map((dataPoint, index) => (
                <FundOverviewDataPoint
                  key={dataPoint.label}
                  dataPoint={dataPoint}
                  index={index}
                  totalCount={dataPoints.length}
                />
              ))}
            </View>
          </View>
        </View>
      </Column>
    </PeriodEndReportPage>
  );
};

export default FundOverview;
